import styled from "styled-components";

const Wrapper = styled.section`
*{
    font-family : McKinsey Sans !important;
}
    position : relative;
    .close{
        position : absolute;
        right : 15px;
        top : 15px;
        padding : 10px;
        width : 32px;
        cursor : pointer;
    }

    ul,p{
        margin : 0;
        padding : 0;
    }

    h1,h2{
        font-weight : 300;
        margin : 0;
    }
    position : fixed;
    height : 100vh;
    width : 100vw;
    background : rgba(0,0,0,0.3);
    box-sizing : border-box;
    top : 0;
    left : 0;
    z-index : 11;
    .container{
        background : #fff;
        width : 700px;
        position : fixed;
        top : 50%;
        left : 50%;
        flex-direction: column;
        transform : translate(-50%, -50%);
        .top {
            h1,h2{
                font-size : 20px;
            }
            padding : 30px;
            ul{
                padding : 10px 20px;
            }
            ul li{
                list-style : none;
                cursor : pointer;
                
                button {
                    width : 100%;
                    text-align : left;
                    box-sizing: border-box;
                    display : flex;
                    background : transparent;
                    border : none;
                    border-bottom : solid thin #ccc;
                    display : flex;
                    align-items : center;
                    justify-content : space-between;
                    padding : 15px 0;
                    cursor : pointer;
                     transition : 0.4s;
                    &:hover{
                        border-left : solid 5px #2251FF;
                        text-indent : 10px;
                        font-weight : bold;
                    }
                    p{
                        color : #000;
                        font-size : 14px;
                    }
                }
            }
            .inner{
                display : flex;
                overflow : hidden;
                align-items : center;
                margin-top : 20px;
                .left {
                    flex : 1;
                    .box{
                        display : block;
                        text-decoration : none;
                        cursor : pointer;
                        transition : 0.4s;
                        img{
                            width : 20px;
                        }
                        padding : 20px;
                        &:last-of-type{
                            margin-top : 20px;
                        }
                        h2{
                            margin : 10px 0;
                            color : #000;
                        }
                        border : solid thin #ccc;
                        p{
                            color : #000;
                        }
                        &:hover{
                            border : solid thin #2251cc;
                            box-shadow : 2px 2px 5px #ccc;
                        }
                    }
                }
                .right {
                    width : 300px;
                    height : 253px;
                    display : flex;
                    flex-flow : column;
                    border : solid thin #ccc;
                    margin : 0px 0 0px 20px;
                    .head{
                        display : flex;
                        align-items : center;
                        width : 100%;
                        border-bottom : solid thin #ccc;
                        padding : 10px 20px;
                        box-sizing : border-box;
                    }
                    // h2{
                    //     margin-left : 10px;
                    // }
                    ul{
                      overflow : auto;  
                    }
                }
            }
        }

        .queryForm{
            padding : 30px;
            .back{
                background : none;
                border : none;
                color : #888;
                font-weight : bold;
            }
            h2{
                margin-top : 30px;
            }
            p{
                margin : 20px 0;
            }
            textarea{
                width : 100%;
                border : solid thin #ccc;
                padding : 10px;
                box-sizing : border-box;
                margin-top : 10px;
                resize : none;
            }
            .send{
                background : #2251FF;
                color : #fff;
                font-weight : bold;
                padding : 15px 40px;
                margin-top : 20px;
                border : none;
            }
        .primary {
          -webkit-box-align: center;
          align-items: center;
          display: inline-flex;
          border-radius: 0px;
          justify-content: space-around;
          text-align: center;
          vertical-align: middle;
          min-width: 80px;
          white-space: nowrap;
          box-sizing: border-box;
          position: relative;
          outline: none;
          border: 0px;
          background: #2251ff;
          color: rgb(255, 255, 255) !important;
          box-shadow: transparent 0px 0px 0px 1px inset;
          cursor: pointer;
          font-family: "McKinsey Sans", "Helvetica Neue", Calibri, Corbel, Helvetica, Roboto, Droid, sans-serif;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.5;
          padding: 0.4375rem 0.75rem;
          height: 2.5rem;
        }
        .primary:disabled {
          -webkit-box-align: center;
          align-items: center;
          display: inline-flex;
          border-radius: 0px;
          justify-content: space-around;
          text-align: center;
          vertical-align: middle;
          min-width: 80px;
          white-space: nowrap;
          box-sizing: border-box;
          position: relative;
          outline: none;
          border: 0px;
          background: #1537ba;
          color: rgb(255, 255, 255) !important;
          box-shadow: transparent 0px 0px 0px 1px inset;
          font-family: "McKinsey Sans", "Helvetica Neue", Calibri, Corbel, Helvetica, Roboto, Droid, sans-serif;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.5;
          padding: 0.4375rem 0.75rem;
          height: 2.5rem;
          cursor: not-allowed;
          transform: none;
        }
        }

        .bottom {
            display : flex;
            align-items : center;
            padding : 20px 30px;
            .box{
                min-width : 150px;
                display : flex;
                align-items : center;
                p{
                    color : #fff;
                }
            }
        }
    }
    h1{
        color : #000;
    }

    .inner{
        display : flex;
    }

    .bottom{
        background: #051C2C;
    }
`

export default Wrapper